import { Shader } from "@/components/feature/Shader";
import { Header } from "@/components/feature/Header";

export default function Home() {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <Shader />
      <Header />
      <div className="relative z-10 flex min-h-screen flex-col justify-center px-8 md:px-20 text-left">
        <h1
          data-shader-hover
          className="font-funnel font-bold text-white text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-4xl"
        >
          Grain Gradient Shader
        </h1>
        <p
          data-shader-hover
          className="mt-6 text-base md:text-lg text-white/80 font-funnel max-w-xl"
        >
          Move your cursor to feel the blob shift, split, and warm up.
        </p>
      </div>
    </div>
  );
}